import { Stack } from '@mui/material';
import { useAtomValue } from 'jotai';
import { FC, useEffect, useState } from 'react';
import { Loader } from '../../../../components/Loader/Loader';
import { primaryOrDefaultCaptableStateJ } from '../../../../services/state/CapTableDataStateJ';
import { useInvalidateCaptables } from '../../CapTable/useInvalidateCaptables';
import { HelpMessage } from '../../components/Messages/HelpMessage';
import { selectedCompanyIdProfileAtom } from '../../state/UIStateJ';
import { AllScenarios } from './AllScenarios';

export const ScenariosWrapper: FC = () => {
  const { loading, captable } = useLoadCapTableData();

  if (loading) {
    return <Loader />;
  }

  if (!captable) {
    return (
      <Stack mt='2rem'>
        <HelpMessage severity='info' message='Cap table not available for company' />
      </Stack>
    );
  } else if (!captable.captableInvestments?.length) {
    return (
      <Stack mt='2rem'>
        <HelpMessage severity='info' message='Shareholder details are not available for this company' />
      </Stack>
    );
  } else if (captable.fullyDilutedShares === 0) {
    return (
      <Stack mt='2rem'>
        <HelpMessage severity='info' message='Cap Table error - Total FDS for a share class is zero' />
      </Stack>
    );
  }

  return <AllScenarios />;
};

const useLoadCapTableData = () => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const invalidateCaptables = useInvalidateCaptables();
  const selectedCaptable = useAtomValue(primaryOrDefaultCaptableStateJ(companyId));
  const selectedCaptableId = selectedCaptable?.id;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (companyId) {
      if (selectedCaptable) {
        invalidateCaptables(companyId, selectedCaptable);
      }
      setLoading(false);
    }
    // Depend on the primitive id, not the object: invalidateCaptables always refetches fresh data,
    // so `selectedCaptable` gets a new reference every call even when the id is unchanged — depending
    // on the object here would loop (effect -> invalidate -> new reference -> effect -> ...).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, selectedCaptableId, invalidateCaptables]);

  return { loading, captable: selectedCaptable };
};
